import { render, staticRenderFns } from "./MainModern.vue?vue&type=template&id=5517832c&"
import script from "./MainModern.vue?vue&type=script&lang=js&"
export * from "./MainModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,MenuSubmenuModern: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/SubmenuModern.vue').default})
